'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-237/node_modules/@eliadmin/core/src/components/claim/claim-form.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/c222423dbe41").then(m => ({ default: m.ClaimForm })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-237/node_modules/@eliadmin/core/src/components/claim/claim-form.tsx").ClaimForm>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-237/node_modules/@eliadmin/core/src/components/claim/claim-form.tsx").ClaimForm;
export { Island0 as ClaimForm };
